import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { Copy } from 'common/svg';

interface IComponentProps {
  sellerCode?: string;
  buyerCode?: string;
}

export const Code: FC<IComponentProps> = ({ sellerCode, buyerCode }) => {
  const copySellerCode = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(`${sellerCode}`);
  };

  const copyBuyerCode = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(`${buyerCode}`);
  };

  if (sellerCode) {
    return (
      <Tooltip
        title={
          <div className="flex align-center gap-3">
            {sellerCode}
            <Copy className="icon-dark-grey cursor-pointer" onClick={copySellerCode} />
          </div>
        }
        overlayInnerStyle={{ padding: '8px 10px' }}
      >
        <span className="ff-regular fs-xs color-dark-grey">{sellerCode}</span>
      </Tooltip>
    );
  }

  if (!sellerCode && buyerCode) {
    return (
      <Tooltip
        title={
          <div className="flex align-center gap-3">
            {buyerCode}
            <Copy className="icon-dark-grey cursor-pointer" onClick={copyBuyerCode} />
          </div>
        }
        overlayInnerStyle={{ padding: '8px 10px' }}
      >
        <span className="ff-medium fs-xs color-bright-green">{buyerCode}</span>
      </Tooltip>
    );
  }

  return null;
};
